import UnitDetails from './myCompany/UnitDetails/UnitDetails';

const unsubscribeMailButton = document.getElementById(
	'unsubscribePrintingMailButton',
);
if (unsubscribeMailButton) new UnitDetails(unsubscribeMailButton);
